import axios from 'axios';

export default async function prospectPut(prospectInfo, _appStatus) {
  try {
    await axios.put(
      `${process.env.REACT_APP_MCCC_API_URL}/bizheloc/onboard`,
      {
        email: prospectInfo.email,
        firstName: prospectInfo.firstName,
        lastName: prospectInfo.lastName,
        phone: prospectInfo.phone,
        businessName: prospectInfo.businessName,
        methodOfContact: prospectInfo.methodOfContact,
        isMember: `${prospectInfo.isMember === 'Yes'}`,
        application_data: {
          property_address: prospectInfo.application_data.address || '-',
          property_zip: prospectInfo.application_data.zipCode || '-',
          property_city: prospectInfo.application_data.city || '-',
          loan_amount: prospectInfo.application_data.requestedLoanAmount || '0',
          current_mortgage: prospectInfo.application_data.currentMortgageAmount || '0',
          est_property_price: prospectInfo.application_data.estimatedPropertyPrice || '0',
          property_type: prospectInfo.application_data.occupancyType || '-',
          user_credit: prospectInfo.application_data.credit,
          comment: prospectInfo.application_data.anythingElseQuestion || '-',
        },
      },
    );
  } catch (error) {
    console.error(error);
    return error.response.status;
  }
}

export async function prospectFinalSubmit(prospectInfo) {
  try {
    // first do a final update of the prospect
    await prospectPut(prospectInfo);

    // next put the final status change on the prospect
    const response = await axios.put(
      `${process.env.REACT_APP_MCCC_API_URL}/bizheloc/finalize`,
      {
        email: prospectInfo.email,
        phone: prospectInfo.phone,
      },
    );
    return response;
    // return { status: 200 };
  } catch (error) {
    console.error(error);
    return error.response.status;
  }
}

export function formatPhoneNumber(value) {
  if (!value) return value;
  // replaces all non integer characters
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  // formats number to be (xxx) xxx
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  // formats number to be (xxx) xxx-xxxx
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}
